export default __webpack_public_path__ + "static/media/7 - Подготовка к сдаче ГТО.e7aca617.jpg";